import React, { useEffect, useState } from "react";
import Header from "../components/Common/Header/Header";
import Footer from "../components/Common/Footer";
import "./pageCSS/StuentOpp.css";
import Marquee from "react-fast-marquee";

const StudentOpportunity = () => {
  const [advocate, setAdvocate] = useState([]);
  const [ourTeamList, setOurTeamList] = useState([]);
  // console.log(ourTeamList, 10)
  useEffect(() => {
    fetch("https://lawacademyadmin.icicle.dev/api/advocateList")
      .then((res) => res.json())
      .then((data) => {
        setAdvocate(data);
      });
  }, []);

  useEffect(() => {
    fetch("https://lawacademyadmin.icicle.dev/api/OurTeamList")
      .then((res) => res.json())
      .then((data) => {
        setOurTeamList(data);
      });
  }, []);

  // CSS file
  const rowStyle = {
    display: "inline-flex",
    gap: "50px",
    // height: '250px'
  };

  return (
    <div>
      <Header />
      <div className="opportunity_section container memory-page">
        <div style={{ display: "flex", justifyContent: "center", alignItems: "end" }}>
          <p style={{ fontWeight: "bold", fontSize: "25px", width: "280px" }}>Advocate List</p>
          <div style={{ border: "1px dashed #1C245B", width: "100%" }} />
        </div>
        <div>
          <hr />
          <Marquee speed={100}>
            <div data-aos="zoom-in-left" className="row" style={rowStyle}>
              {advocate.map((item, index) => (
                <div key={index} className="card">
                  <img
                    className="student_opportunity_img"
                    src={`https://lawacademyadmin.icicle.dev/${item?.image}`}
                    alt="Name 1"
                  />
                  <h4
                    className="text-center"
                    style={{ margin: "10px 0", color: "#1C245B", fontWeight: 600 }}
                  >
                    {item.name}
                  </h4>
                </div>
              ))}
            </div>
          </Marquee>

          {/* Our Student */}
        
          <div data-aos="zoom-in-right">
          <div
            style={{
              textAlign: "left",
              margin: "50px 0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
              gap: "5px",
            }}
          >
            {/* <hr className="hr_Style" style={{ border: "2px dotted #1C245B", width: "80%" }} /> */}
            <div style={{ border: "1px dashed #1C245B", width: "100%" }} />
            <p style={{ fontWeight: "bold", fontSize: "25px", width: "280px" }}> Team Members</p>
          </div>
          <hr />
          <Marquee direction="right" speed={100}>
            <div  className="row" style={rowStyle}>
              {ourTeamList.map((item, index) => (
                <div key={index} className="card">
                  <img
                    className="student_opportunity_img"
                    src={`https://lawacademyadmin.icicle.dev/${item?.image}`}
                    alt="Name 1"
                  />
                  <h4 style={{ textAlign: "center" }}>{item.name}</h4>
                </div>
              ))}
            </div>
          </Marquee>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StudentOpportunity;
